import axAPI from "../../../api/axios-instance";
import {
  TvCollection,
  TvMatchRef,
  TvSlide,
  TvSyncResult,
  TvTag,
  TvTagType,
  TvVideo,
} from "../Lib";

// Запросы раздела ТВ, которые не укладываются в CRUD провайдера.

export const searchTvMatches = async (
  leagueId: number,
  q?: string
): Promise<TvMatchRef[]> => {
  const { data } = await axAPI.get("cms/tv/matches/search", {
    params: { leagueId, q: q || undefined, limit: 20 },
  });
  return data;
};

export const searchTvTags = async (
  type: TvTagType,
  q?: string,
  leagueId?: number
): Promise<TvTag[]> => {
  const { data } = await axAPI.get("cms/tv/tags/search", {
    params: { type, q: q || undefined, leagueId, limit: 20 },
  });
  return data;
};

export const searchTvVideos = async (
  q?: string,
  showId?: number
): Promise<TvVideo[]> => {
  const { data } = await axAPI.get("cms/tv/videos", {
    params: { q: q || undefined, showId, limit: 20 },
  });
  return data.items;
};

export const getTvVideo = async (id: number): Promise<TvVideo> => {
  const { data } = await axAPI.get(`cms/tv/videos/${id}`);
  return data;
};

export const setTvCollectionItems = async (
  id: number,
  videoIds: number[]
): Promise<TvCollection> => {
  const { data } = await axAPI.put(`cms/tv/collections/${id}/items`, {
    videoIds,
  });
  return data;
};

export const reorderTvSlides = async (ids: number[]): Promise<TvSlide[]> => {
  const { data } = await axAPI.put("cms/tv/showcase/order", { ids });
  return data;
};

export const runTvSync = async (full: boolean): Promise<TvSyncResult> => {
  const { data } = await axAPI.post("cms/tv/sync", null, { params: { full } });
  return data;
};
